import Singleton from "./Singleton"
import {message} from "antd";
import axios from "axios";
import {redirect} from 'react-router-dom'

const LOCALES = {
  errors: {
    generic: "Chyba při zpracování dat.",
    runtime_exception: "Chyba při zpracování dat.",
    bad_request_exception: "Chyba při zpracování dat.",
    invalid_credentials_exception: "Neplatné přihlašovací údaje.",
    not_enough_capacity_exception: "Zvolený časový slot je již obsazen a nelze rezervovat. Vyberte si prosím jiný.",
    email_default: "Neplatný e-mail.",
    email_already_exists: "Uvedený email již v systému existuje. Obnovte si své heslo, nebo zadejte jiný email.",
    phone_default: "Neplatný telefon.",
    phone_invalid_value_format: "Neplatný telefon.",
    unsafe_password: "Heslo musí mít alespoň 8 znaků, včetně velkého písmene a číslice.",
    passwords_not_equal: "Hesla nejsou stejná.",
    mandatory: "Položky označené * jsou povinné.",
    property_value_invalid_value_format: "Neplatná hodnota vlastnosti.",
    reward_id_not_allowed_value: "Tuto odměnu lze použít pouze v procesu nákupu.",
    email_not_found: "E-mail nebyl nalezen.",
    property_value_already_exists_rodne_cislo: "Rodné číslo/Číslo pojištěnce již existuje. Použijte jiné nebo si obnovte heslo.",
    property_value_invalid_value_format_rodne_cislo: "Rodné číslo/Číslo pojištěnce má neplatný formát.",
  },
  points: "bod|body|bodů"
}

export default class App extends Singleton {

  static API_URL = (document.location.hostname === "localhost") ? "http://localhost/" : `https://${document.location.hostname}/api/`
  touched_flag = false
  static STORE = {
    is_authorized: false,
    customer_id: null,
    is_test_user: null
  }

  static getCustomerID () {
    return App.STORE.customer_id || null
  }

  constructor() {
    super()

    this.message = message

    axios.interceptors.response.use((response) => {

      return response.data

    }, (error) => {

      if(error.hasOwnProperty('response') && error.response.hasOwnProperty('error'))
        return Promise.reject(error.response.data)
      else if(error.hasOwnProperty('message'))
        return Promise.reject(error.message)
      else
        return Promise.reject("No internet connection")

    })

    window.$app = this
  }

  async $api(request) {
    return new Promise(async (resolve, reject) => {

      try {
        const { action = 'default', headers = null } = request

        delete request.headers

        const response = await axios({
          withCredentials: true,
          url: `${App.API_URL}?action=${action}`,
          method: 'POST',
          headers: headers,
          data: {
            ...request
          }
        })

        if(response && response.hasOwnProperty('error')) reject(response.error)
        else resolve(response)

      } catch (error) {

        reject(error)

      }
    })
  }

  $t(...keys) {
    return this.findByKeys(keys, LOCALES)
  }

  $tc(...args) {

    const count = args.pop()
    const plurals = this.findByKeys(args, LOCALES).split("|").map(item => item.trim())

    if(count === 1)
      return plurals[0]
    if(plurals.length === 3 && (4 < count || count === 0))
      return plurals[2]

    return plurals[1]
  }

  findByKeys(keys, data) {

    // Result key found
    if(keys.length === 0)
      return data

    if (data[keys[0]] !== undefined ) {
      let original = keys.shift()
      return this.findByKeys(keys, data[original])
    } else {
      console.error(`JS lang key ${keys} not exist`)
      return `[JS lang key ${keys} not exist]`
    }
  }

  static $toast (content, type = "success", conf = {}) {
    void message.open({type: type, content: content, ...conf})
  }
  static $e(content) {
    this.$toast(content, "error")
  }

  $e(content) {
    App.$e(content)
  }

  /**
   *
   * @returns {Promise<{is_test_user: null, is_authorized: boolean, customer_id: null}>}
   */
  async $auth () {
    if(!this.touched_flag) {
      let data = await this.$api({action: "touch"})
      App.STORE = data
      this.touched_flag = true
    }

    return App.STORE
  }

  handleError(error) {
    console.log("Error handler: ", error)

    if(typeof error === 'string')
      return this.$e(error)

    // ERRORS FROM BRIDGE
    if(typeof error === 'object' && error.hasOwnProperty('errors')) {
      error.errors.forEach((item) => {
        this.$e(`${item.title || ""}`)
      })
      return
    }

    if(typeof error === 'object') {

      const { error_data = {}, exception } = error
      const { invalid_params = [] } = error_data

      const messages = invalid_params.map(({name, reason, specific_parameter_name = null}) => {
        if(specific_parameter_name !== null)
          return this.$t('errors', `${name}_${reason ? reason : 'default'}${specific_parameter_name ? `_${specific_parameter_name}` : ''}`)
        else
          return this.$t('errors', `${name}_${reason ? reason : 'default'}`)
      })

      if(messages.length)
        return this.$e(messages.join('\n'))

      // Customer is logged out => Redirect to login
      if(exception === "customer_not_logged_in_exception") {
        redirect("/")
        return null
      }

      if(exception)
        return this.$e(this.$t('errors', exception))

      return this.$e(this.$t('errors', 'generic'))

    }

    return this.$e(this.$t('errors', 'generic'))
  }
}

export const $app = App.instance